import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UiConfirm } from './shared/ui/confirm';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, UiConfirm],
  templateUrl: './app.html',
})
export class App {}
